import { useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { track } from '../utils/analytics';

/**
 * Sending messages in a clip's chat. While a reply is on its way, `pendingMessage` holds what the
 * user sent so the thread can show it straight away; once answered, both saved messages go to
 * appendMessages. send() throws when it fails, so the composer keeps the text.
 */
export const useClipChat = (clipId, { appendMessages, onCredits } = {}) => {
  const { authFetch } = useAuth();
  const [pendingMessage, setPendingMessage] = useState(null);

  const send = useCallback(async (message) => {
    const content = message.trim();
    if (!content) return;
    setPendingMessage(content);
    track('chat_message');
    try {
      const result = await authFetch(`/clips/${clipId}/chat`, { method: 'POST', json: { message: content } });
      appendMessages?.(result.data.messages);
      if (result.data.credits_remaining !== undefined) onCredits?.(result.data.credits_remaining);
      return result.data.response;
    } finally {
      setPendingMessage(null);
    }
  }, [authFetch, clipId, appendMessages, onCredits]);

  return { send, pendingMessage, isSending: pendingMessage !== null };
};
